<template>
  <div>
    <template>
      <div class="text-xs-center">
        <v-dialog content-class="dialog" persistent v-model="dialog" width="500">
          <v-card>
            <v-card-text>
              <v-text-field
                id="text_field"
                type="text"
                v-model="layer"
                :label="label"
                tabindex="-1"
                required
                @keyup.enter="saveChanges"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveChanges">
                {{
                $t("pallet_structure_edit.save")
                }}
              </v-btn>
              <v-btn color="primary" flat @click="dialog = false">
                {{
                $t("pallet_dimensions.close")
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import Pallet from "@/models/Pallet.js";
export default {
  data() {
    return {
      dialog: false,
      layerNumber: 0,
      layer: "",
      plankWidth: 70,
      pallet: {}
    };
  },
  computed: {
    label() {
      return `${this.layerNumber}${this.$t("pallet_structure_edit.layer")}`;
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        document.addEventListener("keyup", e => {
          if (e.key === "Escape") {
            this.dialog = false;
          }
        });
      }
    }
  },
  methods: {
    /**
     * opens dialog, sets data
     * @param pallet
     * @param layer
     */
    async openDialog(pallet, layer) {
      this.dialog = true;
      this.layerNumber = layer;
      this.pallet = await Pallet.loadPallet(pallet.id);
      this.layer = this.getDisplayString(this.pallet, layer);
      this.plankWidth = this.getPlankWidth(this.pallet, layer);
      const textField = document.getElementById("text_field");
      setTimeout(() => {
        textField.focus();
      }, 50);
    },

    getPlankWidth(pallet, layer){
      const layerIndex = this.getLayerIndex(layer);
      const layerString = pallet.pallet_structure[layerIndex];
      const layerParts = layerString.split(" ");
      return parseInt(layerParts[1]);
    },

    /**
     * saves changes in the database
     */
    async saveChanges() {
      //check if anything changed
      if (this.noChanges()) {
        this.dialog = false;
        return 0;
      }
      if (this.incorectInput()) {
        alert(this.$t("pallet_structure_edit.malformed_data"));
        return 1;
      }
      //save
      await this.pallet.pallet_structure.save(this.formData());
      this.$emit("updated", this.pallet);
      this.dialog = false;
    },

    /**
     * forms data to input correct layer
     */
    formData() {
      let data = {};
      const layerIndex = this.getLayerIndex(this.layerNumber);
      data[layerIndex] = this.getNewLayer(this.layer);
      return data;
    },

    /**
     * gets string to upload from
     * recorded layer
     * @param layer
     */
    getNewLayer(givenLine) {
      const splitLayers = givenLine.split(" ");
      let layers = splitLayers.filter(e => {
        return e != null && e != "";
      });

      const spacingMode = layers.find(e => {
        return e.toLowerCase() === "x";
      });

      //if need to insert layers in between
      if (spacingMode) {
        return this.findWithSpacingMode(layers);
      }
      //if standart layers
      return this.findInNormalMode(layers);
    },

    /**
     * tries to put within pallet
     * when there are spacing x's
     * @param planks
     */
    findWithSpacingMode(planks) {
      //first check if first or last planks are x's return without them, because not valid format
      if (
        planks[0].toLowerCase() == "x" ||
        planks[planks.length - 1].toLowerCase() == "x"
      ) {
        const newPlanks = planks.filter(e => {
          return e.toLowerCase() != "x";
        });
        return this.findInNormalMode(newPlanks);
      }
      let spacingModeLayer = "";
      for (let i = 0; i < planks.length; i++) {
        let spaceNeeded = false;
        if (planks[i].toLowerCase() != "x") {
          let coordinateX = planks[i];
          if (i != 0) {
            coordinateX -= this.plankWidth;
          }
          spacingModeLayer += coordinateX;
          spaceNeeded = true;
        } else {
          let numberOfXs = 1;
          if (planks[i - 1].toLowerCase() != "x") {
            while (planks[i + numberOfXs].toLowerCase() == "x") {
              numberOfXs++;
            }
            let gapStart = planks[i - 1];
            if (i - 1 != 0) {
              gapStart -= this.plankWidth;
            }
            let gapEnd = planks[i + numberOfXs] - this.plankWidth;
            const spaceBetween = gapEnd - gapStart;
            const sectionLength = Math.floor(spaceBetween / (numberOfXs + 1));

            let currentPosition = parseInt(gapStart);
            for (let i = 0; i < numberOfXs; i++) {
              currentPosition += sectionLength;
              spacingModeLayer += currentPosition + " ";
            }
          }
        }

        if (i != planks.length - 1 && spaceNeeded) {
          spacingModeLayer += " ";
        }
      }
      return spacingModeLayer;
    },

    /**
     * just forms a string when there are no x's
     * @param planks
     */
    findInNormalMode(planks) {
      let standartLayer = "";
      for (let i = 0; i < planks.length; i++) {
        let coordinateX = parseInt(planks[i]);
        if (i != 0) {
          coordinateX -= this.plankWidth;
        }
        standartLayer += coordinateX;
        if (i < planks.length - 1) {
          standartLayer += " ";
        }
      }
      return standartLayer;
    },

    /**
     * gets a string that is displayed and to be editted
     * (also good for checking if any changes)
     * @param pallet
     * @param layer
     */
    getDisplayString(pallet, layer) {
      const layerIndex = this.getLayerIndex(layer);
      const layerString = pallet.pallet_structure[layerIndex];
      const splitLayers = layerString.split(" ");
      let layersFiltered = splitLayers.filter(e => {
        return e != null && e != "";
      });
      const layersStart = layersFiltered.slice(0, 2);
      let layersEnd = layersFiltered.slice(2);
      layersEnd.sort((a, b) => {
        return a - b;
      });
      const layers = layersStart.concat(layersEnd);
      this.plankWidth = parseInt(layers[1]);
      let displayString = "";
      for (let i = 2; i < layers.length; i++) {
        let coordinateX = parseInt(layers[i]);
        if (i != 2) {
          coordinateX += this.plankWidth;
        }
        displayString += coordinateX;
        if (i < layers.length - 1) {
          displayString += " ";
        }
      }
      return displayString;
    },

    /**
     * returns true if display string is not changed
     */
    noChanges() {
      return this.getDisplayString(this.pallet, this.layerNumber) == this.layer;
    },

    /**
     * returns true if input is not correct
     * not correct if:
     * 1. string empty
     * 2. if string entered
     * 3. if out of bounds (bigger than pallet itself)
     * 4. layers would sit on top of each other
     */
    incorectInput() {
      let error = false;
      const splitLayers = this.layer.split(" ");
      const layers = splitLayers.filter(e => {
        return e != null && e != "";
      });
      //if empty or spaces inside
      if (layers.length == 0) {
        return true;
      }
      //takes plank width from current pallet structure
      const plankWidth = parseInt(
        this.pallet.pallet_structure[
          this.getLayerIndex(this.layerNumber)
        ].split(" ")[1]
      );
      layers.forEach(layer => {
        //check if some of the layers are not a number or s special code
        if (isNaN(layer) && layer.toLowerCase() != "x") {
          error = true;
        }
        //check if is out of bounds
        const column = this.layerNumber == 2 ? "width" : "length";
        if (layer < 0 || layer > this.pallet[column]) {
          error = true;
        }
        //check if layers overlap
        if (this.layersOverlap(layers, plankWidth)) {
          error = true;
        }
      });
      return error;
    },

    /**
     * layser overlap if distance between them is smaller
     * than layer width
     * @param layers
     * @param layerWidth
     */
    layersOverlap(layers, layerWidth) {
      let overlap = false;
      loop1: for (let i = 0; i < layers.length; i++) {
        for (let j = 0; j < layers.length; j++) {
          if (i != j) {
            if (Math.abs(layers[i] - layers[j]) < layerWidth) {
              overlap = true;
              break loop1;
            }
          }
        }
      }
      return overlap;
    },

    getLayerIndex(layer) {
      return "layer_" + layer;
    }
  }
};
</script>

<style>
#button {
  display: none;
}
.dialog {
  position: absolute !important;
  bottom: 20px !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
}
</style>
